var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1200 800" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "0 0 1200 800",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { transform: "matrix(2.95976 0 0 2.949 179 66)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_1_", d: "M-300.9-224h909v678h-909z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_1_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_2_)" } },
          [
            _c("path", {
              staticStyle: { fill: "#d6d7d8" },
              attrs: { d: "M121.3 148.6h69.9v77.8h-69.9z" },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: { d: "M78 223.9h156.5v6H78z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_3_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-141.014",
                  y1: "247.015",
                  x2: "166.105",
                  y2: "247.015",
                  gradientTransform:
                    "matrix(2.9598 0 0 -2.949 417.369 827.865)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_3_)" },
              attrs: { d: "M0 0h307.1v198.8H0z" },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: { d: "M5.4 5h296.3v163.8H5.4z" },
            }),
            _c("ellipse", {
              staticStyle: { fill: "#eee" },
              attrs: { cx: "284.5", cy: "183.5", rx: "25.9", ry: "25.8" },
            }),
          ],
          1
        ),
      ]),
      _c("g", { attrs: { transform: "matrix(3.07 0 0 3.07 646 109)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_4_", d: "M-103.5-103.5h307v307h-307z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_5_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_4_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_5_)" } }, [
          _c("circle", {
            staticStyle: { fill: "#eaeaed" },
            attrs: { cx: "50", cy: "50", r: "50" },
          }),
        ]),
      ]),
      _c("g", { attrs: { transform: "matrix(.82 0 0 .81754 326 310)" } }, [
        _c("defs", [
          _c("path", { attrs: { id: "SVGID_6_", d: "M27 26h246v233H27z" } }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_7_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_6_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_7_)" } }, [
          _c("path", {
            staticClass: "st9",
            attrs: {
              id: "star-i2",
              d: "m150 0 46.4 93.8L300 108.9l-75 73L242.7 285 150 236.3 57.3 285 75 181.9l-75-73 103.6-15.1z",
            },
          }),
        ]),
      ]),
      _c("g", { attrs: { transform: "matrix(.26667 0 0 .26667 757 449)" } }, [
        _c("defs", [
          _c("path", { attrs: { id: "SVGID_8_", d: "M110 104.5h80v76h-80z" } }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_9_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_8_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_9_)" } }, [
          _c("path", {
            staticClass: "st9",
            attrs: {
              id: "star-i3",
              d: "m150 0 46.4 93.8L300 108.9l-75 73L242.7 285 150 236.3 57.3 285 75 181.9l-75-73 103.6-15.1z",
            },
          }),
        ]),
      ]),
      _c("g", { attrs: { transform: "matrix(.26667 0 0 .26667 854 449)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_10_", d: "M110 104.5h80v76h-80z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_11_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_10_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_11_)" } }, [
          _c("path", {
            staticClass: "st9",
            attrs: {
              id: "star-i4",
              d: "m150 0 46.4 93.8L300 108.9l-75 73L242.7 285 150 236.3 57.3 285 75 181.9l-75-73 103.6-15.1z",
            },
          }),
        ]),
      ]),
      _c("g", { attrs: { transform: "matrix(.26667 0 0 .26667 660 449)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_12_", d: "M110 104.5h80v76h-80z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_13_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_12_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_13_)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "star-i5_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "5625.938",
                  y1: "3781.828",
                  x2: "5625.938",
                  y2: "4365.708",
                  gradientTransform: "translate(-683.39 -543.452) scale(.1481)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d5d5ee" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#star-i5_1_)" },
              attrs: {
                id: "star-i5",
                d: "m150 0 46.4 93.8L300 108.9l-75 73L242.7 285 150 236.3 57.3 285 75 181.9l-75-73 103.6-15.1z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", { attrs: { transform: "matrix(.26667 0 0 .26667 952 449)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_14_", d: "M110 104.5h80v76h-80z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_15_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_14_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_15_)" } }, [
          _c("path", {
            staticClass: "st9",
            attrs: {
              id: "star-i6",
              d: "m150 0 46.4 93.8L300 108.9l-75 73L242.7 285 150 236.3 57.3 285 75 181.9l-75-73 103.6-15.1z",
            },
          }),
        ]),
      ]),
      _c("g", { attrs: { transform: "matrix(.26667 0 0 .26667 562 449)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_16_", d: "M110 104.5h80v76h-80z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_17_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_16_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_17_)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "star-i8_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "5993.438",
                  y1: "3781.828",
                  x2: "5993.438",
                  y2: "4365.708",
                  gradientTransform:
                    "translate(-737.828 -543.452) scale(.1481)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d5d5ee" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#star-i8_1_)" },
              attrs: {
                id: "star-i8",
                d: "m150 0 46.4 93.8L300 108.9l-75 73L242.7 285 150 236.3 57.3 285 75 181.9l-75-73 103.6-15.1z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", { attrs: { transform: "matrix(2.62668 0 0 2.6414 715 182)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_18_", d: "M-53.3-46h172v148h-172z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_19_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_18_" },
          }),
        ]),
        _c("path", {
          staticClass: "st4",
          staticStyle: { "clip-path": "url(#SVGID_19_)" },
          attrs: {
            d: "M42.3 40.6h-1.2C49 37.6 54.6 30 54.6 21c0-11.6-9.4-21-21-21s-21 9.4-21 21c0 8.9 5.6 16.6 13.5 19.6h-2.9C12.8 40.6 3.8 47 0 56h65.5c-3.8-9-12.8-15.4-23.2-15.4z",
          },
        }),
      ]),
      _c("g", { attrs: { transform: "matrix(1.13867 0 0 1.13787 59 122)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_20_", d: "M-26-37.5h427v619H-26z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_21_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_20_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_21_)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_hand-i9_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-9170.23",
                  y1: "-2992.302",
                  x2: "-7300.767",
                  y2: "-2392.517",
                  gradientTransform:
                    "matrix(-.08324 -.0139 .01388 -.08318 -446.713 -108.799)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f29b94" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_hand-i9_1_)" },
              attrs: {
                id: "L_hand-i9",
                d: "M199.2 226.1c8.7 5.5 16.5 10.4 22 13.7 22.1 13.2 35.3 21.6 45.3 40.2 10 18.5 10.3 19.4 21 30.7s36.8 8 37 6.9-27.1-26.8-8.7-14.8c18.4 12 30.1 2.5 17.6-1.8-12.4-4.3-29-21.6-33.3-26.6-4.5-4.9 1.2-7.1 13.7-3.5 12.5 3.7 17.4-3.8 9.2-4.9-8.2-.8-17.8-10.3-34.7-13.1-16.9-2.8-29.3-18.9-54-40.4-3.2-2.7-6.3-5.8-9.3-8.9l-25.8 22.5z",
              },
            }),
            _c(
              "g",
              { attrs: { id: "shoes-i9" } },
              [
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "L_shoe-i9_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "5503.115",
                      y1: "6962.429",
                      x2: "7167.934",
                      y2: "7385.036",
                      gradientTransform:
                        "matrix(.08438 0 0 .08432 -469.365 -77.499)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#28306d" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#1f275f" },
                      attrs: { offset: ".51" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#171f51" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#L_shoe-i9_1_)" },
                  attrs: {
                    id: "L_shoe-i9",
                    d: "M18.4 492.3 0 544h130s-6.7-12.9-28.9-22.4c-22.2-9.5-42.9-29.2-42.9-29.2l-39.8-.1",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#28306d" },
                  attrs: {
                    id: "R_shoe-i9",
                    d: "M115.3 492.4 96.9 544h130s-6.7-12.9-28.9-22.4c-22.2-9.5-42.9-28.9-42.9-28.9l-39.8-.3",
                  },
                }),
              ],
              1
            ),
            _c("g", { attrs: { id: "trousers-i9" } }, [
              _c("path", {
                staticStyle: { fill: "#0d94c6" },
                attrs: {
                  id: "L_trousers-i9",
                  d: "M110.7 329c-6.2 25-5.3 18.7-6.1 62.7-.4 23-17 32.4-15.6 62.5.1 2.7.3 5 .4 7.1-5.6 18.7-9.4 31.2-9.4 31.2l-69-.3c-2-17.5-1.4-35.2 1.8-52.6 5.3-29.5 16.6-40 20-62.6 5.5-36 12-52 25.9-73.5 13.5-20.9 36.9-50.9 28.5-102.7-.9-5.8-1.8-11.3-2.5-16.5 3.7 12.6 8.7 24.9 14.8 36.5 36.9 70.6 14.2 96.1 11.2 108.2z",
                },
              }),
              _c("path", {
                staticClass: "st2",
                attrs: {
                  id: "R_trousers-i9",
                  d: "M124.7 134c-16.3 24.9-7.6 47.1-1.2 56.5 7.8 11.2 10.6 19.6 14 46.8 3.3 27.1 26.8 38.3 26.8 38.3l32.2-27.1c2.9 14.1 5.1 28.3 6.4 42.7 2.8 31.9-27.5 176.1-32.9 201.6l-75.6-.5c-3.4-17.7-4.6-22.2-5.3-38.1-1.4-30 15.1-39.5 15.6-62.5.9-43.9-.1-37.7 6.1-62.7 3-12.1 25.7-37.6-11.2-108-34.3-65.4-19.2-118.1-14.1-132.2",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  id: "texure-i9",
                  d: "M98.5 113c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm5 0c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm3.1 19.9c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1 0-.1.2 0 .3zm3.6-3.6c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3zm3.6-3.6c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1.1-.1.3 0 .3zm-10.8-3.2c0 .1.2.2.3.1s.2-.2.1-.3-.2-.2-.3-.1c-.1.1-.1.2-.1.3zm4.7-1.9c0 .1.1.1.2.1s.1-.1.1-.1v-.1c0-.1-.2-.2-.3-.1 0 0-.1.1 0 .2zm8.8 15.6c0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.3 0-.3.1zm2-4.6c0 .1 0 .2.1.3.1.1.2 0 .3-.1 0-.1 0-.2-.1-.3-.2-.1-.3-.1-.3.1zm-37.8-8.2c.1.2.3.3.5.3.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.3-.2.1-.3.3-.2.5zm9.1-3c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5zm9.1-3c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5zm-.9 39.3c-.1.2 0 .4.2.5.2.1.4 0 .5-.1.1-.2 0-.4-.2-.5-.2-.2-.4-.1-.5.1zm4.3-8.6c-.1.2 0 .4.2.5s.4 0 .5-.2c.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2zm4.3-8.6c-.1.2 0 .4.2.5.2.1.4 0 .5-.1.1-.2 0-.4-.2-.5-.2-.2-.4-.1-.5.1zm4.3-8.5c-.1.2 0 .4.2.5.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4-.1-.5.2 0-.1 0-.1 0 0zM83 106.5c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4zm9.5.7c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.4-.4-.1-.1-.2.1-.3.3zM84.8 141c.1.2.4.2.6 0 .2-.1.2-.4 0-.6-.1-.2-.4-.2-.5 0-.2.2-.2.4-.1.6zm7.2-6.3c.1.2.4.2.6 0 .2-.1.2-.4 0-.6-.1-.2-.4-.2-.5 0-.2.2-.2.5-.1.6zm7.3-6.2c.2.2.4.2.6 0 .2-.1.2-.4 0-.6-.1-.2-.4-.2-.6-.1-.2.2-.2.5 0 .7zm7.2-6.3c.1.2.4.2.6.1.2-.1.2-.4.1-.6s-.4-.2-.6-.1c-.2.2-.2.4-.1.6zm10.8 35.2c0 .2.2.4.4.4s.4-.1.4-.4c0-.2-.1-.4-.3-.4-.2 0-.4.2-.5.4zm1.4-19.1c0 .2.1.4.3.4.2 0 .4-.1.4-.4 0-.2-.2-.4-.4-.4-.1 0-.3.2-.3.4zm-31.1-37.1c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm-8.8 32.5c.1.2.3.2.5.1s.2-.3.1-.5-.3-.2-.5-.1c-.1.2-.2.4-.1.5zm7-4.9c.1.2.3.2.5.1s.2-.3.1-.5-.3-.2-.5-.1-.2.3-.1.5zm6.9-5.2c0 .1 0 .2.1.2.1.2.3.2.5.1s.2-.3.1-.5c-.1-.1-.2-.2-.3-.2-.1 0-.1 0-.2.1s-.2.2-.2.3zm7-4.7c.1.2.3.2.5.1s.2-.3.1-.5-.3-.2-.5-.1c-.1.1-.2.3-.1.5zm9.6 33.7c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm1.4-8.4c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2-.1-.4.1-.4.3zm1.4-8.5c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.3.1-.4.3zm1.4-8.4c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.1 0-.3.1-.4.3zm-30.1-13.8c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3-.4.2-.3.4zm8.3-1.9c0 .2.2.3.4.3s.3-.2.3-.4c-.1-.2-.2-.3-.4-.3s-.3.2-.3.4zm8.4-2c0 .2.2.3.4.3.2-.1.3-.2.3-.4s-.2-.3-.4-.3c-.3.1-.4.2-.3.4zm-6.3 32.3c-.1.2 0 .4.1.5.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.1-.1-.4 0-.5.1zm4.6-7.2c-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1zm4.5-7.3c-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4 0-.5.1zm4.6-7.2c-.1.2-.1.4.1.5.1.1.2.1.3 0 .1 0 .1-.1.2-.1.1-.2 0-.4-.1-.5-.2-.1-.4-.1-.5.1zM86.8 93c0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.2-.1-.3 0-.3.1zm.7 21.4c.1.1.2.2.3.1.1-.1.2-.2.1-.3-.1-.1-.2-.2-.3-.1-.1.1-.2.2-.1.3zm4.6-2.1c.1.1.2.2.3.1.1 0 .2-.2.1-.3-.1-.1-.2-.2-.3-.1-.1.1-.2.2-.1.3zm4.6-2.1c0 .1.2.1.3.1.1 0 .2-.1.1-.2 0-.1-.2-.1-.3-.1-.1 0-.2.1-.1.2zm6.3 18.5c0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.2 0-.3 0-.3.1zm1.8-4.7c0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.2-.1-.3 0-.3.1zm1.7-4.7c0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1-.1-.2 0-.3.1zm-18.8-16c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2c-.2 0-.2.1-.2.2zm5-.2c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm2.8 18c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0v.3zm3.5-3.7c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3zm3.5-3.7c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3-.1 0-.1 0 0 0zm11 14.2c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zM88.4 95.8c0 .1.1.2.2.3.1 0 .3-.1.3-.2s-.1-.3-.2-.3c-.2 0-.3 0-.3.2zm-6.2 21.8c.1.1.2.1.3.1.1-.1.1-.2.1-.3-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3zm4.8-3.3c.1.1.2.1.3.1.1-.1.1-.2.1-.3-.1-.1-.2-.1-.3-.1-.2.1-.2.2-.1.3-.1 0 0 0 0 0zm4.7-3.3c.1.1.2.1.3.1.1-.1.1-.2.1-.3-.1-.1-.2-.1-.3-.1-.2.1-.2.2-.1.3zm4.7-3.2c.1.1.2.1.3.1.1-.1.1-.2.1-.3 0-.1-.1-.1-.2-.1h-.2s-.1.1 0 .3zm6.2 22.7c0 .1 0 .2.2.3.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3-.2 0-.3.1-.3.2zm1-5.6c0 .1.1.3.2.3s.2-.1.3-.2c0-.1-.1-.2-.2-.3-.1 0-.3 0-.3.2zm1-5.7c0 .1 0 .2.2.3.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3-.1 0-.2.1-.3.2zm-18.7-15.1c0 .1.2.2.3.2.1 0 .2-.1.2-.3 0-.1-.2-.2-.3-.2-.2 0-.2.2-.2.3zm5.6-1.3c0 .1.1.2.3.2.1 0 .2-.1.2-.3 0-.1-.1-.2-.3-.2-.1.1-.2.2-.2.3zm1.2 20.8s.1 0 0 0c.2.1.3.1.4 0 .1-.1 0-.2-.1-.3-.1-.1-.3 0-.3.1v.2zm3.1-5.1c-.1.1 0 .2.1.3.1.1.3 0 .3-.1.1-.1 0-.3-.1-.3-.1-.1-.2 0-.3.1zm3.1-4.9c-.1.1 0 .3.1.3s.3 0 .3-.1 0-.3-.1-.3c0 0-.2 0-.3.1zm15.4 14c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.1-.1-.2-.3-.2-.1 0-.2.2-.2.3zM89.1 99.5c.1.2.3.4.5.3.2-.1.4-.3.3-.5-.1-.2-.3-.4-.5-.3-.2.1-.3.3-.3.5zm-8.7 34.1c-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.4-.1-.6-.3-.1-.5 0-.6.1zm5.1-8.4c-.1.2 0 .4.1.6.2.1.4 0 .6-.2.1-.2 0-.4-.2-.6-.1 0-.4 0-.5.2zm5.2-8.4c-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.4-.1-.6-.3-.1-.5-.1-.6.1zm5.1-8.4c-.1.2-.1.4.1.6.2.1.4 0 .6-.1.1-.2.1-.4-.1-.6-.2-.2-.5-.1-.6.1zm20.4 40.5c.1.2.3.4.5.3.2-.1.3-.3.3-.5-.1-.2-.3-.3-.5-.3s-.4.3-.3.5zm-2.3-9.6c.1.2.3.4.5.3.2-.1.4-.3.3-.5-.1-.2-.3-.4-.5-.3-.2 0-.4.3-.3.5zm-2.3-9.6c.1.2.3.4.5.3.2-.1.4-.3.3-.5-.1-.2-.3-.3-.5-.3s-.4.3-.3.5zm-2.3-9.6c.1.2.3.4.5.3.2-.1.4-.3.3-.5-.1-.2-.3-.3-.5-.3s-.4.2-.3.5zM87 107.7c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.2-.2.4-.1.6zm8.1 37.2c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3-.1-.5 0-.5.3zm1.5-9.8c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3-.1-.5.1-.5.3zm1.5-9.8c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.2 0-.4.1-.5.3zm1.6-9.7c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3-.1-.5.1-.5.3zm-12.9-14.7c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.5-.1-.3.2-.3.4-.2.6zm1.5 44.6c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.2-.1-.5.1-.5.3zm2-9.7c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3 0-.5.1-.5.3zm1.9-9.6c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.2-.1-.5.1-.5.3zm2-9.6c-.1.2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3-.1-.5 0-.5.3zm1.9-9.7c0 .2.1.4.3.5h.2c.1 0 .3-.2.3-.3 0-.2-.1-.4-.3-.5-.2-.1-.5.1-.5.3zm-13.6 9.3c-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.4-.1-.6-.2-.1-.5-.1-.6.1zm5.5-8.1c-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.4-.1-.6-.2-.2-.5-.1-.6.1zm20.3 32.5c0 .2.3.4.5.3.2 0 .4-.3.3-.5 0-.2-.2-.4-.5-.3-.2.1-.3.3-.3.5zm-1.9-9.6c0 .2.3.4.5.3.2 0 .4-.3.3-.5 0-.2-.2-.4-.5-.3-.2 0-.3.2-.3.5zm-1.9-9.7c0 .2.3.4.5.3.2 0 .4-.3.3-.5 0-.2-.3-.4-.5-.3-.2.1-.3.3-.3.5zm-1.9-9.6c.1.2.3.4.5.3.2 0 .4-.3.3-.5 0-.2-.3-.4-.5-.3-.2 0-.3.2-.3.5zm-20.9-9.1c.1.1.3.1.4 0 .1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0-.1 0-.1.2 0 .4zm5.2-5.3c.1.1.3.1.4 0 .1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0-.1 0-.1.2 0 .4 0-.1 0 0 0 0zm8.1 32.6c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.3zm-.1-7.4c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.3zm0-7.4c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.2-.1-.3.1-.3.3zm-.1-7.5c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.2 0-.3.2-.3.3zm-14 15.6c-.1.2 0 .3.2.4.2.1.3 0 .4-.2.1-.2 0-.3-.2-.4-.2-.1-.3 0-.4.2 0-.1 0 0 0 0zm2.7-6.9c-.1.2 0 .3.2.4.2.1.3 0 .4-.2.1-.1 0-.3-.2-.4-.1-.1-.3 0-.4.2zm2.8-6.9c-.1.2 0 .3.2.4.1.1.3 0 .4-.1.1-.2 0-.3-.2-.4-.1-.1-.3-.1-.4.1zm2.8-6.9c-.1.2 0 .3.2.4.2.1.3 0 .4-.2.1-.2 0-.3-.2-.4-.2 0-.4 0-.4.2zm20.1 20.8c.1.2.2.2.4.2.2-.1.2-.2.2-.4-.1-.2-.3-.2-.4-.1-.2 0-.3.2-.2.3zm-2.9-6.8c.1.2.3.2.4.2.1-.1.2-.2.2-.4-.1-.2-.3-.2-.4-.2-.2.1-.3.2-.2.4zm-21-9.2c0 .1 0 .2.1.2s.2 0 .2-.1 0-.2-.1-.2c0 0-.1.1-.2.1zm.9-3.9c0 .1 0 .2.1.2s.2 0 .2-.1 0-.2-.1-.2-.1 0-.2.1zm.9-4c0 .1 0 .2.1.2s.2 0 .2-.1 0-.2-.1-.2-.2 0-.2.1zm.9-3.9c0 .1 0 .2.1.2s.2 0 .2-.1 0-.2-.1-.2-.2 0-.2.1zm-2.5-3.6c-.1.1 0 .2 0 .2h.2c.1-.1 0-.2 0-.2h-.2c.1 0 0 0 0 0zm8.1 13.6c0 .1.1.1.2.1s.2-.1.1-.2c0-.1-.1-.1-.2-.1 0 0-.1.1-.1.2zm-.7-4c0 .1.1.2.2.1.1 0 .2-.1.1-.2 0-.1-.1-.2-.2-.1 0 .1-.1.1-.1.2zm-5.7 13.7c0 .1.2.2.3.2.1 0 .2-.1.2-.3 0-.1-.1-.2-.3-.2-.1 0-.2.1-.2.3zm-1.1-6.6c0 .1.1.2.3.2.1 0 .3-.2.2-.3 0-.2-.2-.3-.3-.2-.1 0-.2.1-.2.3zM85 102c0 .2.2.3.3.2.2 0 .3-.2.2-.3 0-.2-.2-.3-.3-.2-.1 0-.2.1-.2.3zm-1.1-6.6c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.2-.2-.3-.3-.2-.1 0-.3.1-.2.3zm14.8 11.8c.1.1.2.2.4.1.1-.1.2-.3.1-.4-.1-.1-.2-.2-.4-.1-.1.1-.1.3-.1.4z",
                },
              }),
            ]),
            _c(
              "g",
              { attrs: { id: "sweater-i9" } },
              [
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "sweater-2-i9_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "7715.432",
                      y1: "1003.554",
                      x2: "7236.064",
                      y2: "3160.714",
                      gradientTransform:
                        "matrix(.08438 0 0 .08432 -469.365 -77.499)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#28306d" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#1f275f" },
                      attrs: { offset: ".51" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#171f51" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#sweater-2-i9_1_)" },
                  attrs: {
                    id: "sweater-2-i9",
                    d: "M265.1 56.1c-1.6 2.1-2.9 4.4-3.8 6.8-60 9.3-92.3 26.2-124.3 56.5-4.7 4.4-8.9 9.3-12.4 14.7-23.5-18.1-51.5-63.8-51.5-63.8 13.5-28.1 40.3-24.8 61.5-23.3 21.2 1.5 33.8-10.2 70.4-6.2s60.1 15.3 60.1 15.3z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#23286b" },
                  attrs: {
                    id: "R_sleeve-i9",
                    d: "M270.3 87.8s-35.6 27.4-51.9 51.4-14.6 31.2-.2 51.5 18.7 23.7 18.7 23.7l-72.6 61.1s-23.5-11.2-26.8-38.3-6.2-35.5-14-46.8c-7.7-11.3-18.5-40.7 13.6-71.2S201.7 72 262.4 62.7",
                  },
                }),
              ],
              1
            ),
            _c(
              "g",
              { attrs: { id: "head-i9" } },
              [
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "neck-i9_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "8643.526",
                      y1: "1789.856",
                      x2: "9005.817",
                      y2: "1789.856",
                      gradientTransform:
                        "matrix(.08438 0 0 .08432 -469.365 -77.499)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#ffbeb6" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#f2a19c" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#neck-i9_1_)" },
                  attrs: {
                    id: "neck-i9",
                    d: "m286.7 77.3-21 14s-12.8-19.2-.6-35.2l8.8-.5c.7 6.2 4.1 12.4 11.3 20.3.5.5 1 1 1.5 1.4z",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "face-i9_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "9897.924",
                      y1: "1640.735",
                      x2: "10754.551",
                      y2: "1640.735",
                      gradientTransform:
                        "matrix(.08438 0 0 .08432 -469.365 -77.499)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#ffbeb6" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#f2a19c" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#face-i9_1_)" },
                  attrs: {
                    id: "face-i9",
                    d: "M337.4 68.3c-3.7 5.1-6.9 10.5-9.6 16.2-2.7 6.3-9.6-2-9.6-2s-20.9 6.7-33-6.6c-7.2-7.9-10.6-14.1-11.3-20.3 7.2.2 7.7-2.9 8.4-4.8 2.1-5.2-.3-14.9 6.1-15.8 5.9-.9 7.6 4.1 9.6 7.2 2.5 3.5 20.3 21.6 39.4 26.1z",
                  },
                }),
                _c("path", {
                  staticClass: "st27",
                  attrs: {
                    id: "eye-i9",
                    d: "M316.3 64c.2 3.7 3.3 6.5 7 6.3 1.3-.1 2.6-.5 3.7-1.3.8-.6 0-2-.8-1.4-2.2 1.8-5.4 1.5-7.2-.7-.7-.8-1.1-1.8-1.1-2.9-.1-1-1.7-1-1.6 0z",
                  },
                }),
                _c("path", {
                  staticClass: "st27",
                  attrs: {
                    id: "hair-i9",
                    d: "M373.9 53.7c-3.9 9.9-12.7 14.3-22.2 14.8 15.6-3.2 22.2-17.3 22.2-17.3-8.6-3.3-19.5-10-27-15.7-6.3-4.7-13.9-12.8-24.4-24.2-14-15.1-40.1-16.6-51.6 4.5-10 18.4.9 39.8.9 39.8.5 0 1 0 2.1-.1 7.2.2 7.7-2.9 8.5-4.8 2.1-5.2-.3-14.9 6.1-15.8 5.9-.8 7.6 4.1 9.6 7.2 2.5 3.8 22.3 24 42.8 26.8.6.1 1.1.1 1.7.2 12.9 2.3 27-1.5 32.3-15.1.3-.6-.7-.9-1-.3z",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }